import {
    convertUniversalDateTimeToPersianDateTime, dataURLtoFile,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary, RaikoConfirmDialog, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import {MagazineSliderService} from "../../serverService/magazineService/MagazineSliderService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import {stringIsEmpty} from "../../util/VariableChecker";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";

export default function SliderDetail() {

    const {id: sliderId = -1} = useParams()
    const {state} = useLocation()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineSliderDetail.name);

    const navigate = useNavigate()

    const service = new MagazineSliderService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [photoFile, setPhotoFile] = useState(null)
    const [photoUrl, setPhotoUrl] = useState("");

    const [name, setName] = useState("");
    const [writer, setWriter] = useState("")
    const [link, setLink] = useState("")
    const [description, setDescription] = useState("")

    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");

    const [enabled, setEnabled] = useState(true);
    const [photoId, setPhotoId] = useState(-1);


    useEffect(() => {
        getDataFromServer()
    }, []);

    function getDataFromServer() {

        loading.show()
        service.getSliderDetail(sliderId)
            .then(response => {
                setName(response.title)
                setWriter(response.authorInformation)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.postedAt))
                setCreatedBy(response.postedBy)
                setLink(response.url)
                setDescription(response.description)

                if (response.photo) {
                    setPhotoId(response.photo.id)
                    setPhotoUrl([response.photo.url])
                }
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateInfo() {
        if (checkFields()) {
            loading.show()
            service.updateSliderInfo(
                sliderId,
                name,
                writer,
                link,
                description,
                photoId,
                photoFile,
                enabled
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(name))
            message = "لطفا عنوان اسلایدر را وارد نمایید."
        else if (stringIsEmpty(writer))
            message = "لطفا نویسنده اسلایدر را وارد نمایید."
        else if (stringIsEmpty(link))
            message = "لطفا لینک مقصد را وارد نمایید."
        else if (stringIsEmpty(description))
            message = "لطفا توضیحات را وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }


    function handleDeleteSlider() {
        loading.show()
        service.updateSliderInfo(
            sliderId,
            name,
            writer,
            link,
            description,
            photoId,
            null,
            false
        ).then(response => {
            showSuccessMessage("حذف اسلایدر با موفقیت انجام شد.")
            closeDeleteDialog()
            navigate(
                RouteHelper.MagazineSlider.globalUrl,
                {replace: true}
            )
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    const [openDialog, setOpenDialog] = useState(false);
    const openDeleteDialog = () => setOpenDialog(true)
    const closeDeleteDialog = () => setOpenDialog(false)

    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        setPhotoUrl(imgSrc)
        setPhotoFile(imageFile)
    }

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.MagazineSliderDetail.name}</title>
            </Helmet>

            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openDialog}
                doAction={handleDeleteSlider}
                pageTitle={"حذف اسلایدر"}
                warningTitle={"آیا از حذف اسلایدر اطمینان دارید؟"}
            />


            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.MagazineSlider.name,
                                    RouteHelper.MagazineSlider.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""),
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"اطلاعات پایه"}
                            actionButtonOnclick={handleUpdateInfo}
                            actionButtonTitle={"بروزرسانی"}
                            hasActionButton
                            hasSecondaryButton
                            secondaryButtonTitle={"حذف اسلایدر"}
                            secondaryButtonOnClick={openDeleteDialog}
                        >
                            <RaikoGridOneColumn>
                                <RaikoGridOneColumn>

                                    <RaikoSectionContainer
                                        title={"تصویر شاخص"}
                                    >
                                        <UploadThumbnail
                                            avatarFile={photoUrl}
                                            updateAvatar={handleSelectImage}
                                            loading={false}
                                            aspectRatio={12 / 5}
                                        />
                                    </RaikoSectionContainer>


                                    <RaikoGridTwoColumn>
                                        <RaikoMaterialOutlinedInput
                                            labelText={"عنوان"}
                                            value={name}
                                            setValue={setName}
                                        />
                                        <RaikoMaterialOutlinedInput
                                            labelText={"نویسنده"}
                                            value={writer}
                                            setValue={setWriter}
                                        />
                                    </RaikoGridTwoColumn>
                                    <RaikoMaterialOutlinedInput
                                        labelText={"لینک مقصد"}
                                        value={link}
                                        setValue={setLink}
                                    />
                                    <RaikoSimpleMultiLineInputOutlined
                                        labelText={"توضیحات"}
                                        value={description}
                                        setValue={setDescription}
                                    />
                                </RaikoGridOneColumn>
                            </RaikoGridOneColumn>

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>


                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
